module.exports = __webpack_public_path__ + "static/media/background-boardwalk-clouds-808465.e22e7026.jpg";